import { RESTAURANT_STATUS_LABEL, type RestaurantStatus } from '@garlic/shared';
import { Badge } from '../ui/primitives';

export function StatusBadge({ status }: { status: RestaurantStatus }) {
  const tone = status === 'ACTIVE' ? 'success' : status === 'SUSPENDED' ? 'danger' : 'warning';
  return (
    <Badge tone={tone} dot>
      {RESTAURANT_STATUS_LABEL[status]}
    </Badge>
  );
}
